<div class="primary-key">
    <span class="invalid-data-icon" id="infoInvalidDataIcon" *ngIf="invalidData">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use>
        </svg>
    </span>
    <cxone-checkbox id="checkboxId" type="checkbox" checkboxId="{{primaryKeyId}}"
        [(ngModel)]="params.node.data.isPrimaryKey" name="primaryKey"
        (clicked)="onPrimaryKeyChange($event)" [disabled]="disablePrimaryKey || isPreview"></cxone-checkbox>
</div>